.jy{bottom:0.25rem;}